import { IconProps } from './index';

const ArrowLeftLine: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M6.523 9.167h10.143v1.666H6.523l4.47 4.47-1.178 1.179L3.333 10l6.482-6.482 1.178 1.179-4.47 4.47z"
                fill="currentColor"
            />
        </svg>
    );
};

export default ArrowLeftLine;
